// Module
var code = "<div class=\"Posing\"> Posing As {{PosingBanner.name}}, {{PosingBanner.email}}, sponsored by: '{{PosingBanner.sponsorName}}' </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/header/posingBanner/posingBanner.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;